<template>
    <AddFileSection
        :id="AddFileFormSectionIds.REQUEST_WIRE_INFORMATION"
        sectionDescription="Select clients to request wire information for this file."
        sectionHeading="Request wire information"
    >
        <ClientMultiSelect
            class="mt-3"
            :error="requestBankInfoRecipientsError"
            :name="REQUEST_BANK_INFO_NAME"
            @update:modelValue="onClientsUpdate"
        />
    </AddFileSection>
</template>

<script setup lang="ts">
import { useAddFileStore } from '@/company-portal/add-file/add-file.store';
import { AddFileFormSectionIds } from '@/company-portal/add-file/add-file.types';
import { REQUEST_BANK_INFO_NAME } from '@/company-portal/add-file/selectors';
import { clearServerValidationError, serverValidationErrors } from '@/company-portal/add-file/submission-error';
import AddFileSection from '@/components/Views/Company/AddFile/AddFileSection.vue';
import ClientMultiSelect from '@/components/Views/Company/AddFile/ClientMultiSelect.vue';
import type { DsMultiSelectClientOption } from '@/components/Views/Company/AddFile/useClientMultiSelect';
import { computed } from 'vue';

const addFileStore = useAddFileStore();

const onClientsUpdate = (clients: DsMultiSelectClientOption[]) => {
    addFileStore.requestWireInfoClientIds = clients.map(client => client.id);
    clearServerValidationError('requestBankInfo_recipients');
};

const requestBankInfoRecipientsError = computed(
    () => serverValidationErrors.value?.['requestBankInfo_recipients']?.join('') ?? '',
);
</script>
